import React, { useState } from 'react';
import { FaUser, FaClock, FaMoneyBill, FaFolder, FaFileAlt, FaBox, FaHistory } from 'react-icons/fa';
import './Menu.css';

const Menu = ({ menuSelected, onChange, employee }) => {
    const [openSubmenu, setOpenSubmenu] = useState(null);
    const [selectedMenu, setSelectedMenu] = useState(menuSelected || null);
    const [selectedParentMenu, setSelectedParentMenu] = useState(null);

    const toggleSubmenu = (menuName) => {
        setOpenSubmenu((prev) => (prev === menuName ? null : menuName));
    };

    const handleMenuSelect = (menuName, parentMenu = null) => {
        setSelectedMenu(menuName);
        setSelectedParentMenu(parentMenu);
        if (onChange) {
            onChange(menuName);
        }
    };

    return (
        <div className="menu m-3">
            <h2 className="text-center">{employee?.name}</h2>
            <hr />
            <div className="menu-section">
                <ul>
                    <li>
                        <div
                            className={`menu-item ${
                                selectedMenu === 'General' || selectedParentMenu === 'General' ? 'active' : ''
                            }`}
                            onClick={() => toggleSubmenu('General')}
                        >
                            <FaUser />&nbsp;General
                        </div>
                        {openSubmenu === 'General' && (
                            <ul className="submenu">
                                <li
                                    className={selectedMenu === 'personal' ? 'active' : ''}
                                    onClick={() => handleMenuSelect('personal', 'General')}
                                >
                                    Personal
                                </li>
                                <li
                                    className={selectedMenu === 'employment' ? 'active' : ''}
                                    onClick={() => handleMenuSelect('employment', 'General')}
                                >
                                    Employment
                                </li>
                                <li
                                    className={selectedMenu === 'education_experience' ? 'active' : ''}
                                    onClick={() => handleMenuSelect('education_experience', 'General')}
                                >
                                    Education & Experience
                                </li>
                                <li
                                    className={selectedMenu === 'additional_info' ? 'active' : ''}
                                    onClick={() => handleMenuSelect('additional_info', 'General')}
                                >
                                    Additional Info
                                </li>
                            </ul>
                        )}
                    </li>
                    <li>
                        <div
                            className={`menu-item ${
                                selectedMenu === 'Time Management' || selectedParentMenu === 'Time Management'
                                    ? 'active'
                                    : ''
                            }`}
                            onClick={() => toggleSubmenu('Time Management')}
                        >
                            <FaClock />&nbsp;Time Management
                        </div>
                        {/* 
                        
                         */}
                        {openSubmenu === 'Time Management' && (
                            <ul className="submenu">
                                <li
                                    className={selectedMenu === 'attendance' ? 'active' : ''}
                                    onClick={() => handleMenuSelect('attendance', 'Time Management')}
                                >
                                    Attendance
                                </li>
                                <li
                                    className={selectedMenu === 'timeoff' ? 'active' : ''}
                                    onClick={() => handleMenuSelect('timeoff', 'Time Management')}
                                >
                                    Timeoff
                                </li>
                                <li
                                    className={selectedMenu === 'overtime' ? 'active' : ''}
                                    onClick={() => handleMenuSelect('overtime', 'Time Management')}
                                >
                                    Overtime
                                </li>
                            </ul>
                        )}
                    </li>
                    {/* Other menu items */}
                    <li>
                        <div
                            className={`menu-item ${selectedMenu === 'payroll' ? 'active' : ''}`}
                            onClick={() => handleMenuSelect('payroll')}
                        >
                            <FaMoneyBill />&nbsp;Payroll
                        </div>
                    </li>
                    <li>
                        <div
                            className={`menu-item ${
                                selectedMenu === 'Finance' || selectedParentMenu === 'Finance' ? 'active' : ''
                            }`}
                            onClick={() => toggleSubmenu('Finance')}
                        >
                            <FaFolder /> Finance
                        </div>
                        {openSubmenu === 'Finance' && (
                            <ul className="submenu">
                                <li
                                    className={selectedMenu === 'reimbursement' ? 'active' : ''}
                                    onClick={() => handleMenuSelect('reimbursement', 'Finance')}
                                >
                                    Reimbursement
                                </li>
                                <li
                                    className={selectedMenu === 'loan' ? 'active' : ''}
                                    onClick={() => handleMenuSelect('loan', 'Finance')}
                                >
                                    Loan
                                </li>
                            </ul>
                        )}
                    </li>
                    <li>
                        <div
                            className={`menu-item ${selectedMenu === 'Files' ? 'active' : ''}`}
                            onClick={() => handleMenuSelect('Files')}
                        >
                            <FaFileAlt /> Files
                        </div>
                    </li>
                    <li>
                        <div
                            className={`menu-item ${selectedMenu === 'Assets' ? 'active' : ''}`}
                            onClick={() => handleMenuSelect('Assets')}
                        >
                            <FaBox /> Assets
                        </div>
                    </li>
                    <li>
                        <div
                            className={`menu-item ${selectedMenu === 'History' ? 'active' : ''}`}
                            onClick={() => handleMenuSelect('History')}
                        >
                            <FaHistory /> History
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Menu;
